const object = vnObject

document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-open-excerpt');
    if (!btn) return;

    const parent = btn.parentElement;
    const content = parent.querySelector('.js-excerpt-content');
    const label = btn.querySelector('.vn-a-content');

    if (content) {
        content.classList.toggle('is-open');

        if (label) {
            label.textContent = content.classList.contains('is-open')
                ? object.readLess
                : object.readMore;
        }
    }
});